import { render, staticRenderFns } from "./GJgrowEventCreateTermSurveyAtAfter.vue?vue&type=template&id=9fb71210&scoped=true&"
import script from "./GJgrowEventCreateTermSurveyAtAfter.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventCreateTermSurveyAtAfter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb71210",
  null
  
)

export default component.exports